import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import GlobalStyleSheet from "nx-components/GlobalStyleSheet";
import prefixStyles from "nx-components/utils/prefixStyles";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import tileLegacyStyles from "nexia_mobile/components/Tiles/tileLegacyStyles";
import DeviceTile from "nexia_mobile/components/Tiles/DeviceTile";
import AutomationTile from "nexia_mobile/components/Tiles/AutomationTile";
import PhoneTile from "nexia_mobile/components/Tiles/PhoneTile";
import BuildingTile from "nexia_mobile/components/Tiles/BuildingTile";
import BuildingInfoTile from "nexia_mobile/components/Tiles/BuildingInfoTile";
import ErrorHandler from "nexia_mobile/components/ErrorHandler";
import AutomationModel from "nexia_mobile/models/automation";
import DeviceModel from "nexia_mobile/models/device";
import PhoneModel from "nexia_mobile/models/phone";
import LocationModel from "nexia_mobile/models/location";
import DrawUpdates from "nexia_mobile/components/DrawUpdates";

const tileStyles = {
  contents: prefixStyles({
    position: "absolute",
    top: "0.125em",
    left: "0.125em",
    bottom: "0.125em",
    right: "0.125em",
    textAlign: "center",
    background: "#fff",
    color: "#808080",
    overflow: "hidden",
    border: "1px solid #d0d0d0",
    borderRadius: "2px",
    transformStyle: "preserve-3d",
  }),
  icon: {
    fontSize: "2.5em",
  },
  title: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "0.5em",
    fontSize: "0.85em",
  },
  status: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#808080",
    fontSize: "0.65em",
    textTransform: "uppercase",
    padding: "0 0.1em",
  },
};

if (
  typeof CSS === "undefined" ||
  typeof CSS.supports !== "function" ||
  !CSS.supports("display", "grid")
) {
  GlobalStyleSheet.preload("nexia_mobile_tile_legacy", tileLegacyStyles);
}

export default class Tile extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  render() {
    const { model } = this.props;

    let TileClass;
    let tileType = "";
    if (model instanceof DeviceModel) {
      TileClass = DeviceTile;
      tileType = model.getDeviceTypeString();
    } else if (model instanceof AutomationModel) {
      TileClass = AutomationTile;
      tileType = "Automation";
    } else if (model instanceof PhoneModel) {
      TileClass = PhoneTile;
      tileType = "Phone";
    } else if (model instanceof LocationModel) {
      if (model.getDeviceListingView()) {
        TileClass = BuildingInfoTile;
        tileType = "group";
      } else {
        TileClass = BuildingTile;
        tileType = "Location";
      }
    }

    return (
      <ErrorHandler>
        <React.Fragment>
          <DrawUpdates
            listenTo={model}
            events={["change"]}
            getNodeToStyle={() => this._el}
          />
          <div className="tile-aspect-ratio">
            <div
              className="tile"
              data-tile-type={tileType}
              data-model-cid={model.cid}
              style={{
                width: "100%",
                paddingBottom: "120%",
                position: "relative",
              }}
              ref={(el) => (this._el = el)}
            >
              <BackboneListener listenTo={model} events={["change"]}>
                {() => <TileClass model={model} tileStyles={tileStyles} />}
              </BackboneListener>
            </div>
          </div>
        </React.Fragment>
      </ErrorHandler>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/Tile.jsx